import { useT } from "@/i18n/useT";
import type common from "@/i18n/locales/picks/common";
import type { TranslateParams } from "@/i18n/registry";

export type GuideMessageKey = keyof (typeof common)["ru"] & string;

export function useGuideT() {
  const { locale, t } = useT();

  return {
    locale,
    t: (key: GuideMessageKey, params?: TranslateParams): string =>
      t(key, params),
  };
}
